import { BillingProvider } from './context/BillingContext'
import { UIProvider } from './context/UIContext'
import TeamBillingPage from './TeamBillingPage'

interface TeamBillingTableProps {
  teamId: string
  canEdit: boolean
}

const TeamBillingTable = ({ teamId, canEdit }: TeamBillingTableProps) => (
  <BillingProvider teamId={teamId}>
    <UIProvider>
      <TeamBillingPage teamId={teamId} canEdit={canEdit} />
    </UIProvider>
  </BillingProvider>
)

export default TeamBillingTable
